import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { RecurringTimelineItem } from '../../api/funds-api';
import { recurringChargeStatusColor } from '../funds/recurringChargeStatus';

interface RecurringChargeStatusBadgeProps {
  status: RecurringTimelineItem['status'];
}

const StatusChip = styled(Chip)({
  fontWeight: 600,
  textTransform: 'uppercase',
});

export function RecurringChargeStatusBadge({ status }: RecurringChargeStatusBadgeProps) {
  return (
    <StatusChip
      size="small"
      label={status}
      color={recurringChargeStatusColor(status)}
    />
  );
}
